import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { Component, EventEmitter, Output } from "@angular/core";
import { REVIEW_DATE_TIME_KEYES } from "./../../review-helper";
import { ReviewCardComponent } from "../review-card.component";
import { ReviewFilter } from "../../models/review-filter";
import { ReviewFilterItem } from "../../models/review-filter-item";
import { ReviewService } from "../../review.service";

import * as moment from "jalali-moment";

@Component({
  selector: "sepidz-filter-item-review",
  templateUrl: "./filter-item-review.component.html",
  styleUrls: ["./filter-item-review.component.scss"],
})
export class FilterItemReviewComponent extends ReviewCardComponent {
  items: ReviewFilterItem[];
  @Output() filterStatusChange = new EventEmitter<boolean>();

  constructor(service: ReviewService) {
    super(service);
    this.name = "default-filter-item";
  }

  protected loadItems(filter: ReviewFilter): void {
    this.items = filter.items.filter((item) => !REVIEW_DATE_TIME_KEYES.includes(item.key));
    this.filterStatusChange.emit(this.items.length > 0);
  }

  changed(item: ReviewFilterItem) {
    this.service.removeFilter(this.name, item.key, [item.value], item.valueType, true);
    this.items = this.items.filter((i) => !(i.key === item.key && (i.valueType === "number" || i.valueType === "text" || i.value === item.value)));
    this.filterStatusChange.emit(this.items.length > 0);
  }

  isValidDate(value: string) {
    if (!value || value === null) {
      return false;
    }
    return moment(value, "YYYY-MM-DDTHH:mm:ss", true).isValid() || moment(value, "YYYY-MM-DD", true).isValid();
  }

  clearAll() {
    this.items.forEach((x) => {
      this.service.removeFilter(this.name, x.key, [x.value], x.valueType, true);
    });
    this.items = [];
    this.filterStatusChange.emit(false);
  }

  isValidNumber(value: string) {
    return !isNaN(Number(value));
  }

  isActive(): boolean {
    return this.items && this.items.length > 0;
  }
}
